module.exports = __webpack_public_path__ + "img/wird-webmacherin.785cb6b8.svg";